















































import Vue from 'vue';
// @ts-ignore
import Prism from 'vue-prism-component';

export default Vue.extend({
  name: 'install',
  components: {
    Prism,
  },
  data() {
    return {
      dialog: false,
      texts: {
        npm: `yarn add vue-dynamic-marquee \n // or \n npm i vue-dynamic-marquee`,
        cdn: `\<script src="https://cdn.jsdelivr.net/npm/vue-dynamic-marquee@0.x/dist/vue-dynamic-marquee.umd.min.js"\>\<\/script\>
\<script\>
    Vue.component('dynamic-marquee', window['vue-dynamic-marquee'])
\<\/script\>`,
        global: `//in main.js
    import DynamicMarquee from 'vue-dynamic-marquee';
    Vue.component('dynamic-marquee', DynamicMarquee);`,
        local: `\<template\>
    \<div\>
	    \<dynamic-marquee\>
	        \<!--your content to be animated--\>
	    \<\/dynamic-marquee\>
    \<\/div\>
\</template\>
\<script\>
import DynamicMarquee from 'vue-dynamic-marquee';
\<\/script\>`,
      },
    };
  },
});
